import { Box, Button } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { showUpdatePaymentMethodDialog } from '../actions/organization'
import SavePaymentMethodModal from '../components/Payment/SavePaymentMethodModal'
import { RootState } from '../store'
import PlanDetails from '../components/Payment/PlanandBilling/PlanDetails'
import TotalSeats from '../components/Payment/PlanandBilling/TotalSeats'
import PaymentHistory from '../components/Payment/PlanandBilling/PaymentHistory'
import { useEffect } from 'react'
import { fetchSubscriptionInvoicesAsync } from '../services/paymentService'

function PlansAndBillings() {
  const dispatch = useDispatch<any>()
  const subscription = useSelector(
    (state: RootState) => state.payment.currentSubscriptionPlan,
  )
  const invoices = useSelector(
    (state: RootState) => state.payment.subscriptionInvoices,
  )
  const isShowUpdatePaymentMethodModalDialog = useSelector(
    (state: RootState) => state.organization.showUpdatePaymentMethodModal,
  )

  useEffect(() => {
    dispatch(
      fetchSubscriptionInvoicesAsync({
        subscriptionId: subscription?.subscription_id,
      }),
    )
  }, [dispatch])
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          textAlign: 'end',
        }}
      >
        <Button
          variant='contained'
          onClick={() => dispatch(showUpdatePaymentMethodDialog(true))}
        >
          Update Payment Method
        </Button>
      </Box>
      <SavePaymentMethodModal
        isOpen={isShowUpdatePaymentMethodModalDialog}
        handleClose={() => dispatch(showUpdatePaymentMethodDialog(false))}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 3,
        }}
      >
        <PlanDetails plan={subscription!} />
        <TotalSeats />
      </Box>
      <PaymentHistory invoices={invoices} />
    </Box>
  )
}

export default PlansAndBillings
